import React from 'react';
import { ReactCookieProps, withCookies } from 'react-cookie';
import { HelmetProvider } from 'react-helmet-async';

import './reset.css';
import './App.scss';

import AppRouter from './AppRouter';

import { UserCapabilities, UserCapabilitiesContext } from './lib/UserCapabilities';
import { Locale } from './lib/Locale';
import { Editable } from './lib/Editable';
import { Provider } from 'react-redux';
import { store } from './data/store';

function App(props: ReactCookieProps) {
  const userCapabilities = new UserCapabilities();

  return (
    <HelmetProvider>
      <Provider store={store}>
        <UserCapabilitiesContext.Provider value={userCapabilities}>
          <Editable>
            <Locale cookies={props.cookies}>
              <AppRouter />
            </Locale>
          </Editable>
        </UserCapabilitiesContext.Provider>
      </Provider>
    </HelmetProvider>
  );
}

export default withCookies(App);
